
import Axios  from 'axios'
import VueCookies from 'vue-cookies'
import router from '../router/index.js'
import { Message } from 'element-ui';
import global_  from "@/components/Common/Global";
import QS from 'qs'
// 添加请求拦截器
Axios.defaults.baseURL =global_.BASE_URL+'api/'
// 添加请求拦截器
Axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  config.headers.post['Access-Control-Allow-Origin'] = '*';
  config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  if (VueCookies.get('token')) {
    //用户登录完成之后 ，每次请求都携带请求头的token值，
    config.headers.Authorization = "Bearer " +VueCookies.get('token')
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 响应拦截器，对错误进行想要进行的处理
Axios.interceptors.response.use((response) => {
  if (response.data.code == 401) {
    return router.push({name:'login'})
  }

  if (response.data.code == 409) {
   Message.error(response.data.message);
    VueCookies.remove('token');
    router.push({
      path:"/login",
    })
  }
  return response;
}, (err) => {
  console.log('err',err)

  if (err.response) {
    console.log(err.response);
    if (err.response.data && err.response.status) {


      if (err.response.data.msg)
    {
      Message.error(err.response.data.msg)
    }
     else if (err.response.data.errors) {
       let msg=[]
        let errMessage = JSON.parse(JSON.stringify(err.response.data.errors));
        for (let key in errMessage) {
          msg.push(errMessage[key][0]) ;
        }
        Message.error(msg[0])
      }
      else
      {
        Message.error(err.response.data.message)
      }
      if (err.response.status == 401) {
        // window.location.href = "/login";
        router.push({
          path: "/login",
        })
        VueCookies.remove('token');
      }

    } else {
      Message.error(err.response.data.message);
    }
  }
  return Promise.reject(err)
});
export function get(url, params){
  return new Promise((resolve, reject) =>{
    Axios.get(url, {
          params: params
      }).then(res => {
          resolve(res);
      }).catch(err =>{
          reject(err)
  })
});}

/**
* post方法，对应post请求
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
export function post(url, params,) {
  return new Promise((resolve, reject) => {
    Axios.post(url, QS.stringify(params))
      .then(res => {
          resolve(res);
      })
      .catch(err =>{
          reject(err)
      })
  });
}

/**
* upload，upload
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
export function upload(url, params) {

  return Axios.post(url, params, {
    headers: {"content-type": "multipart/form-data"}
  })
  // return new Promise((resolve, reject) => {
  //   Axios.post(url, QS.stringify(params),{
  //     headers: {"content-type": "multipart/form-data"}})
  //     .then(res => {
  //         resolve(res);
  //     })
  //     .catch(err =>{
  //         reject(err)
  //     })
  // });
}
/**
* put，put
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/
export function put(url, params) {
  return new Promise((resolve, reject) => {
    Axios.put(url, QS.stringify(params))
      .then(res => {
          resolve(res);
      })
      .catch(err =>{
          reject(err)
      })
  });
}
/**
* delete，delete
* @param {String} url [请求的url地址]
*/
export function destroy(url) {
  return new Promise((resolve, reject) => {
    Axios.delete(url)
      .then(res => {
          resolve(res);
      })
      .catch(err =>{
          reject(err)
      })
  });
}

// export default Axios



// WEBPACK FOOTER //
// ./src/restful/axios.js